module.exports = __webpack_public_path__ + "img/cdc-9MVMgP2zhgs-unsplash.71358080.jpg";